import { render, staticRenderFns } from "./Erp6SupplierProfile.vue?vue&type=template&id=2f534c3a&scoped=true&"
import script from "./Erp6SupplierProfile.vue?vue&type=script&lang=js&"
export * from "./Erp6SupplierProfile.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SupplierProfile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Erp6SupplierProfile.vue?vue&type=style&index=1&id=2f534c3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f534c3a",
  null
  
)

export default component.exports